/**
 * Ephemeral cover subject for adjutant rescue assist.
 * NOT Claim B healOwner persist + formation-break chase (rejected: wave 0.55).
 * Soft-HP triage only, one-tick signal — no brain sticky, no kit chase.
 */
import { criticalHp01 } from "./features";
import { unitIsStaffHealer } from "./hero-registry";
import type { RaidUnit } from "../raid-types";

export type CoverSubject = {
  unitId: number;
  x: number;
  y: number;
  crit01: number;
};

/**
 * Soft-HP worst hurt ally (alive). Used as rescue/joint-seat subject only.
 */
export function pickCoverSubject(
  allies: readonly RaidUnit[],
  belowPct: number,
  excludeId?: number,
): CoverSubject | null {
  let best: CoverSubject | null = null;
  for (const a of allies) {
    if (a.hp <= 0) continue;
    if (excludeId != null && a.id === excludeId) continue;
    const crit01 = criticalHp01(a, belowPct);
    if (crit01 <= 0) continue;
    if (
      !best ||
      crit01 > best.crit01 ||
      (crit01 === best.crit01 && a.id < best.unitId)
    ) {
      best = { unitId: a.id, x: a.x, y: a.y, crit01 };
    }
  }
  return best;
}

export function dist2d(
  ax: number,
  ay: number,
  bx: number,
  by: number,
): number {
  return Math.hypot(ax - bx, ay - by);
}

/** True when subject is outside all living healers' staff range. */
export function coverSubjectOutOfStaff(
  subject: CoverSubject,
  healers: readonly RaidUnit[],
): boolean {
  for (const h of healers) {
    if (!unitIsStaffHealer(h)) continue;
    if (dist2d(h.x, h.y, subject.x, subject.y) < h.attackRange) return false;
  }
  return healers.some((h) => unitIsStaffHealer(h));
}
